<template>
  <div class="acmper">

    <!-- 顶部按钮 -->
    <div>

      <button
        class="buttons"
        style="background-color: #ee0a24;"
        @click="$router.back()"
      >返回</button>
      <span style="color:red;margin-left: 10%;font-weight: 700;font-size: 15px;">填写完成,请截图转发至微信群</span>

    </div>
    <!-- /顶部按钮 -->

    <van-tabs v-model="activeName">
      <van-tab
        v-for="(item,index) in List"
        :title="item.date"
        :name="item.date"
        :key="index"
      >
        <div>

          <van-row>
            <van-col
              span="4"
              class="text-center"
            >姓名</van-col>
            <van-col
              span="4"
              class="text-center"
              @click="copys('morning',item)"
            >
              <span>早上</span>
              <van-icon
                style="vertical-align: bottom;"
                name="bill"
                size="15"
                color="#1989fa"
              />
            </van-col>
            <van-col
              span="4"
              class="text-center"
              @click="copys('nooning',item)"
            >
              <span>中午</span>
              <van-icon
                style="vertical-align: bottom;"
                name="bill"
                size="15"
                color="#1989fa"
              />
            </van-col>
            <van-col
              span="4"
              class="text-center"
              @click="copys('evening',item)"
            >
              <span>晚上</span>
              <van-icon
                style="vertical-align: bottom;"
                name="bill"
                size="15"
                color="#1989fa"
              />
            </van-col>
            <van-col
              span="2"
              class="text-center"
            >排便</van-col>
            <van-col
              span="2"
              class="text-center"
            >换衣</van-col>
            <van-col
              span="4"
              class="text-center"
            >洗澡洗头</van-col>
          </van-row>

          <div style="margin-top:5px">
            <div
              v-for="(item2,index2) in item.health"
              :key="index2"
            >
              <van-row
                type="flex"
                style="margin-top:5px"
              >
                <van-col
                  span="4"
                  class="text-center line-h20"
                >{{item2.real_name}}</van-col>
                <van-col
                  span="4"
                  class="text-center"
                >
                  <input
                    type="number"
                    :class="item2.T1>37.5?'red-color':''"
                    :disabled="disable"
                    v-model.number="item2.T1"
                    style="width:60%;text-align: center;"
                    @change="roomChange(item2,'T1',$event)"
                  >
                </van-col>

                <van-col
                  span="4"
                  class="text-center"
                >
                  <input
                    type="number"
                    :class="item2.T2>37.5?'red-color':''"
                    :disabled="disable"
                    v-model.number="item2.T2"
                    style="width:60%;text-align: center;"
                    @change="roomChange(item2,'T2',$event)"
                  >
                </van-col>
                <van-col
                  span="4"
                  class="text-center"
                >
                  <input
                    type="number"
                    :class="item2.T3>37.5?'red-color':''"
                    :disabled="disable"
                    v-model.number="item2.T3"
                    style="width:60%;text-align: center;"
                    @change="roomChange(item2,'T3',$event)"
                  >
                </van-col>
                <van-col
                  span="2"
                  class="text-center"
                >
                  <div @click="onClickCheked(item2,'S')">
                    <van-icon
                      size="20"
                      :name="item2.S?(item2.S=='是'?'checked':'clear'):'circle'"
                      :color="item2.S?(item2.S=='是'?'#1989fa':'#ee0a24'):''"
                    />
                  </div>
                </van-col>
                <van-col
                  span="2"
                  class="text-center"
                >

                  <div @click="onClickCheked(item2,'xiyi')">
                    <van-icon
                      size="20"
                      :name="item2.xiyi?(item2.xiyi=='是'?'checked':'clear'):'circle'"
                      :color="item2.xiyi?(item2.xiyi=='是'?'#1989fa':'#ee0a24'):''"
                    />
                  </div>
                </van-col>
                <van-col
                  span="4"
                  class="text-center"
                >

                  <div @click="onClickCheked(item2,'xizao')">
                    <van-icon
                      size="20"
                      :name="item2.xizao?(item2.xizao=='是'?'checked':'clear'):'circle'"
                      :color="item2.xizao?(item2.xizao=='是'?'#1989fa':'#ee0a24'):''"
                    />
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>

        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import util from '../../../common/util'
export default {
  data() {
    return {
      List: [],
      team_id: '',
      activeName: '',
      job: '',
      disable: false,
      project_id: '',
    }
  },
  created() {
    this.team_id = this.$route.query.team_id
    this.project_id = this.$route.query.project_id

    this.getListInfo()
  },
  methods: {
    // 复制温度
    copys(param, item) {
      // morning  nooning evening
      let valueList = null
      let value = ``

      switch (param) {
        case 'morning':
          valueList = item.health.map((e) => {
            return e.real_name + ' ' + e.T1
          })
          break
        case 'nooning':
          valueList = item.health.map((e) => {
            return e.real_name + ' ' + e.T2
          })
          break
        case 'evening':
          valueList = item.health.map((e) => {
            return e.real_name + ' ' + e.T3
          })
          break
      }
      for (let i = 0; i < valueList.length; i++) {
        // 这里需要将名字换行对齐
        value = value + valueList[i] + '\n'
      }

      console.log(value)
      this.$copyText(value).then(
        (e) => {
          this.$toast('复制成功')
        },
        (e) => {
          this.$toast('复制失败')
        }
      )
    },

    onClickCheked: util['debounce'](function (item, param) {
      if (this.job > 3) {
        return
      }
      this.$axios
        .post('/project/dailyhealthupdate', {
          participant_id: item.id,
          date: this.activeName,
          param: param,
        })
        .then((res) => {
          if (res.data.code == 400) {
            this.$toast(res.data.msg)
            return
          }
          item[param] = res.data.val
        })
    }, 500),

    // onClickCheked(item, param) {
    //   if (this.job > 3) {
    //     return
    //   }

    //   console.log('触发;了')
    //   return
    //   this.$axios
    //     .post('/project/dailyhealthupdate', {
    //       participant_id: item.id,
    //       date: this.activeName,
    //       param: param,
    //     })
    //     .then((res) => {
    //       if (res.data.code == 400) {
    //         this.$toast(res.data.msg)
    //         return
    //       }
    //       item[param] = res.data.val
    //     })
    // },
    async getListInfo() {
      const res = await this.$axios.get('project/dailyhealth', {
        params: {
          team_id: this.team_id,
          project_id: this.project_id,
        },
      })
      if (res.data.code != 200) {
        this.$router.replace({
          path: '/errorPage',
          query: { msg: res.data.msg },
        })
        return
      }
      let data = res.data.data
      this.job = res.data.job
      if (this.job > 3) {
        this.disable = true
      } else {
        this.disable = false
      }

      this.List = data
      this.activeName = res.data.default_date
    },
    roomChange(item, param, e) {
      let value = e.target.value
      this.$axios
        .post('/project/dailyhealthupdate', {
          participant_id: item.id,
          date: this.activeName,
          param: param,
          val: value,
        })
        .then((res) => {
          if (res.data.code == 400) {
            this.$toast(res.data.msg)
            return
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.acmper {
  padding: 30px 10px;
  height: 100%;
}
.buttons {
  color: #fff;
  padding: 10px 30px;
  border: none;
  border-radius: 6px;
}
.text-center {
  text-align: center;
  font-weight: 700;
  padding: 5px 0;
}
.red-color {
  background-color: red !important;
}
</style>